const companiesData = [
    {
      id: 1,
      logo: "/assets/Catalog.png",
      nome: "Relocate Experts",
      endereco: "Av. Paulista, 1234 - São Paulo, SP",
      avaliacao: 4.8,
      contato: "(11) 98765-4321",
      redesocial: [
        { nome: "LinkedIn", url: "https://linkedin.com/company/relocate-experts" },
        { nome: "Instagram", url: "https://instagram.com/relocateexperts" },
      ],
    },
    {
      id: 2,
      logo: "/assets/CompanyBusinessInsider.png",
      nome: "Move&Go",
      endereco: "Rua das Flores, 567 - Rio de Janeiro, RJ",
      avaliacao: 4.6,
      contato: "(21) 12345-6789",
      redesocial: [
        { nome: "Facebook", url: "https://facebook.com/moveandgo" },
        { nome: "Twitter", url: "https://twitter.com/moveandgo" },
      ],
    },
    {
      id: 3,
      logo: "/assets/Untitled UI.png",
      nome: "Home Away",
      endereco: "Praça Central, 45 - Porto, Portugal",
      avaliacao: 4.9,
      contato: "+351 91234-5678",
      redesocial: [
        { nome: "LinkedIn", url: "https://linkedin.com/company/home-away" },
        { nome: "Instagram", url: "https://instagram.com/homeaway" },
      ],
    },
    {
      id: 4,
      logo: "/assets/Sisyphus.png",
      nome: "Easy Relocation",
      endereco: "R. Augusta, 789 - Lisboa, Portugal",
      avaliacao: 4.7,
      contato: "+351 98765-4321",
      redesocial: [
        { nome: "Facebook", url: "https://facebook.com/easyrelocation" },
        { nome: "LinkedIn", url: "https://linkedin.com/company/easy-relocation" },
      ],
    },
    {
      id: 5,
      logo: "/assets/Quotient.png",
      nome: "New Horizons",
      endereco: "Av. Ipiranga, 3500 - Porto Alegre, RS",
      avaliacao: 4.5,
      contato: "(51) 99876-5432",
      redesocial: [
        { nome: "Instagram", url: "https://instagram.com/newhorizons" },
        { nome: "LinkedIn", url: "https://linkedin.com/company/new-horizons" },
      ],
    },
    {
      id: 6,
      logo: "/assets/Layers.png",
      nome: "Safe Move",
      endereco: "Rua das Palmeiras, 123 - Curitiba, PR",
      avaliacao: 4.3,
      contato: "(41) 91234-5678",
      redesocial: [
        { nome: "Facebook", url: "https://facebook.com/safemove" },
        { nome: "Twitter", url: "https://twitter.com/safemove" },
      ],
    },
    {
      id: 7,
      logo: "/assets/Hourglass.png",
      nome: "Next Stop",
      endereco: "Rua Chile, 678 - Salvador, BA",
      avaliacao: 4.9,
      contato: "(71) 99876-5432",
      redesocial: [
        { nome: "Instagram", url: "https://instagram.com/nextstop" },
        { nome: "LinkedIn", url: "https://linkedin.com/company/next-stop" },
      ],
    },
    {
      id: 8,
      logo: "/assets/Circooles.png",
      nome: "Global Mover",
      endereco: "Av. Atlântica, 1234 - Florianópolis, SC",
      avaliacao: 4.8,
      contato: "(48) 98765-4321",
      redesocial: [
        { nome: "Facebook", url: "https://facebook.com/globalmover" },
        { nome: "Instagram", url: "https://instagram.com/globalmover" },
      ],
    },
    {
      id: 9,
      logo: "/assets/Command+R.png",
      nome: "Relocation Plus",
      endereco: "Av. República, 567 - Lisboa, Portugal",
      avaliacao: 4.7,
      contato: "+351 92345-6789",
      redesocial: [
        { nome: "LinkedIn", url: "https://linkedin.com/company/relocationplus" },
        { nome: "Instagram", url: "https://instagram.com/relocationplus" },
      ],
    },
  ];
  
  export default companiesData;
  